<script setup lang="ts">
import type { ICustomField } from '@nova/core';
import CustomFieldLabel from './CustomFieldLabel.vue';

/**
 * Base wrapper component for all custom field inputs.
 * Provides consistent layout with optional icon and label.
 *
 * Used by all field type components to ensure uniform structure.
 */
interface CustomFieldInputBaseProps {
  field: ICustomField;
  fieldIcon?: string;
  displayLabel?: boolean;
  required?: boolean;
}

withDefaults(defineProps<CustomFieldInputBaseProps>(), {
  fieldIcon: '',
  displayLabel: true,
  required: false
});
</script>

<template>
  <div class="custom-field-input-base">
    <v-icon v-if="fieldIcon" class="custom-field-icon mr-2">
      {{ fieldIcon }}
    </v-icon>

    <custom-field-label v-if="displayLabel && field?.label" :field="field" :required="required" />

    <slot />
  </div>
</template>

<style scoped lang="scss">
.custom-field-input-base {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.custom-field-icon {
  align-self: flex-start;
}
</style>
